'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasOnlineService = function hasOnlineService(restaurant, serviceId) {
  var res = _lodash2.default.find(restaurant.services, { id: serviceId, online: true, active: true });
  return res !== undefined;
};

var getDeliveryThreshold = function getDeliveryThreshold(order, config) {
  if (!order.deliveryAreaCustomThreshold) {
    return config.order.delivery.threshold || 0;
  }
  return order.deliveryAreaCustomThreshold || 0;
};

var getTargetRestaurant = function getTargetRestaurant(props, type) {
  var order = props.order,
      merchant = props.app.merchant;

  if (!order.targetRestaurant && !order.restaurant) {
    return null;
  }
  var targetRestaurant = order.targetRestaurant || order.restaurant.id;

  if (typeof targetRestaurant !== 'string') {
    throw new Error('Target restaurant is a not a valid id: ', targetRestaurant);
  }

  if (type !== _constants.ORDER_TYPE_DELIVERY && type !== _constants.ORDER_TYPE_TAKEAWAY) {
    throw new Error('Unknow order type: ', type);
  }

  var found = _lodash2.default.find(merchant.restaurants, { id: targetRestaurant });
  if (!found) {
    throw new Error('Restaurant not found: ', targetRestaurant, merchant.restaurants);
  }

  return found;
};

exports.default = {
  hasOnlineService: hasOnlineService,
  getDeliveryThreshold: getDeliveryThreshold,
  getTargetRestaurant: getTargetRestaurant
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/helpers/restaurant.js
// module id = 194
// module chunks = 0